module.exports = __webpack_public_path__ + "media/images/okra-offers/mobile-img-d005e15986cef6da8c6a7605d41b698f.png";